import { createAction } from '@reduxjs/toolkit';

import type {
  HandoffCreate,
  HandoffDelete,
  HandoffResetHandoffConfigs,
  HandoffSetDefault,
  HandoffUpdate,
} from '@polyai/stream/protobuf/handoff';

const PREFIX = 'handoff';

const createHandoff = createAction<HandoffCreate>(`${PREFIX}/createHandoff`);

const updateHandoff = createAction<HandoffUpdate>(`${PREFIX}/updateHandoff`);

const deleteHandoff = createAction<HandoffDelete>(`${PREFIX}/deleteHandoff`);

const setDefaultHandoff = createAction<HandoffSetDefault>(
  `${PREFIX}/setDefaultHandoff`,
);

const resetHandoffConfigs = createAction<HandoffResetHandoffConfigs>(
  `${PREFIX}/resetHandoffConfigs`,
);

export {
  createHandoff,
  deleteHandoff,
  resetHandoffConfigs,
  setDefaultHandoff,
  updateHandoff,
};
